declare global {
  interface Window {
    analytics: any
  }
}

export enum TrackType {
  INSIGHT_FEED_ROW_TOGGLED = 'INSIGHT_FEED_ROW_TOGGLED',
  INSIGHT_FEED_SHOW_MORE_ACTIVITIES = 'INSIGHT_FEED_SHOW_MORE_ACTIVITIES',
  INSIGHT_FEED_SHOW_MORE_CONTACTS = 'INSIGHT_FEED_SHOW_MORE_CONTACTS',
  INSIGHT_FEED_CONVERSATION_CLICK = 'INSIGHT_FEED_CONVERSATION_CLICK',
  INSIGHT_FEED_OUTREACH_ENROLL_CLICK = 'INSIGHT_FEED_OUTREACH_ENROLL_CLICK',
  INSIGHT_FEED_SALESLOFT_ENROLL_CLICK = 'INSIGHT_FEED_SALESLOFT_ENROLL_CLICK',
  INSIGHT_FEED_LINKEDIN_CLICK = 'INSIGHT_FEED_LINKEDIN_CLICK',
  INSIGHT_FEED_EMAIL_CLICK = 'INSIGHT_FEED_EMAIL_CLICK',
  INSIGHT_FEED_CHAT_CLICK = 'INSIGHT_FEED_CHAT_CLICK',
  INSIGHT_FEED_VIEW_CONTACT = 'INSIGHT_FEED_VIEW_CONTACT',
  INSIGHT_FEED_VIEW_ACCOUNT = 'INSIGHT_FEED_VIEW_ACCOUNT',
  ENGAGEMENT_SCORE_CARD_VIEW_ACTIVITY_CLICK = 'ENGAGEMENT_SCORE_CARD_VIEW_ACTIVITY_CLICK',
  ENGAGEMENT_SCORE_CARD_SEE_MORE_CONTACTS_CLICK = 'ENGAGEMENT_SCORE_CARD_SEE_MORE_CONTACTS_CLICK',
  ENGAGEMENT_SCORE_CARD_VIEW_CONTACT_CLICK = 'ENGAGEMENT_SCORE_CARD_VIEW_CONTACT_CLICK',
  ENGAGEMENT_SCORE_CARD_VIEW_ACCOUNT_CLICK = 'ENGAGEMENT_SCORE_CARD_VIEW_ACCOUNT_CLICK',
  ENGAGEMENT_SCORE_TOOLTIP_HOVER = 'ENGAGEMENT_SCORE_TOOLTIP_HOVER',
  AI_ENGAGEMENT_SCORE_TOOLTIP_HOVER = 'AI_ENGAGEMENT_SCORE_TOOLTIP_HOVER',
  ENGAGEMENT_SCORE_TOOLTIP_VIEW_ACTIVITY_CLICK = 'ENGAGEMENT_SCORE_TOOLTIP_VIEW_ACTIVITY_CLICK',
  AI_ENGAGEMENT_SCORE_TOOLTIP_VIEW_ACTIVITY_CLICK = 'AI_ENGAGEMENT_SCORE_TOOLTIP_VIEW_ACTIVITY_CLICK',
  CONTACT_LIST_CONVERSATION_CLICK = 'CONTACT_LIST_CONVERSATION_CLICK',
  CONTACT_LIST_OUTREACH_ENROLL_CLICK = 'CONTACT_LIST_OUTREACH_ENROLL_CLICK',
  CONTACT_LIST_SALESLOFT_ENROLL_CLICK = 'CONTACT_LIST_SALESLOFT_ENROLL_CLICK',
  CONTACT_LIST_CONTACT_INFO_CLICK = 'CONTACT_LIST_SALESLOFT_ENROLL_CLICK',
  CONTACT_LIST_LINKEDIN_CLICK = 'CONTACT_LIST_LINKEDIN_CLICK',
  CONTACT_LIST_EMAIL_CLICK = 'CONTACT_LIST_EMAIL_CLICK',
  INSIGHT_FEED_SCROLL = 'INSIGHT_FEED_SCROLL',
  SEARCH = 'SEARCH',
  REMOVE_FILTER = 'REMOVE_FILTER',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  FILTER_TOGGLED = 'FILTER_TOGGLED',
  FILTER_ADDED = 'FILTER_ADDED',
  FILTER_GROUP_ADDED = 'FILTER_GROUP_ADDED',
  ACCOUNT_PAGE_ACCESSED = 'ACCOUNT_PAGE_ACCESSED',
  ACTIVITY_PAGE_ACCESSED = 'ACTIVITY_PAGE_ACCESSED',
  NEW_ACTIVITY_URL_ACCESSED = 'NEW_ACTIVITY_URL_ACCESSED',
  ACCOUNT_DETAILS_PAGE_ACCESSED = 'ACCOUNT_DETAILS_PAGE_ACCESSED',
  CONTACT_DETAILS_PAGE_ACCESSED = 'CONTACT_DETAILS_PAGE_ACCESSED',
  FILTER_DASHBOARD_SWITCHED = 'FILTER_DASHBOARD_SWITCHED',
  SAVED_FILTER_CREATED = 'SAVED_FILTER_CREATED',
  SAVED_FILTER_SELECTED = 'SAVED_FILTER_SELECTED',
  SAVED_FILTER_UPDATED = 'SAVED_FILTER_UPDATED',
  SAVED_FILTER_DELETED = 'SAVED_FILTER_DELETED',
  SUBMITTED_FEEDBACK_FORM = 'SUBMITTED_FEEDBACK_FORM',
  UNIFIED_FEED_BETA_OPT_OUT = 'UNIFIED_FEED_BETA_OPT_OUT',
  MANAGE_NOTIFICATIONS_BUTTON_CLICKED = 'MANAGE_NOTIFICATIONS_BUTTON_CLICKED',
  CLOSE_CREATE_SAVED_FILTER_TOOLTIP = 'CLOSE_CREATE_SAVED_FILTER_TOOLTIP',
  CLOSE_MANAGE_NOTIFICATIONS_TOOLTIP = 'CLOSE_MANAGE_NOTIFICATIONS_TOOLTIP',
  ACCOUNT_DETAILS_VIEW_DOMAIN_CLICK = 'ACCOUNT_DETAILS_VIEW_DOMAIN_CLICK',
  ACCOUNT_DETAILS_CONTACT_ROW_CLICK = 'ACCOUNT_DETAILS_CONTACT_ROW_CLICK',
  CONTACT_DETAILS_CHAT_MESSAGE = 'CONTACT_DETAILS_CHAT_MESSAGE',
  CONTACT_DETAILS_VIEW_CHAT = 'CONTACT_DETAILS_VIEW_CHAT',
  CONTACT_DETAILS_SEND_EMAIL = 'CONTACT_DETAILS_SEND_EMAIL',
  CONTACT_DETAILS_COPY_EMAIL = 'CONTACT_DETAILS_COPY_EMAIL',
  CONTACT_DETAILS_VIEW_ACCOUNT = 'CONTACT_DETAILS_VIEW_ACCOUNT',
  UPCOMING_MEETING_DESCRIPTION_HOVER = 'UPCOMING_MEETING_DESCRIPTION_HOVER',
  UPCOMING_MEETING_ACCOUNT_LINK = 'UPCOMING_MEETING_ACCOUNT_LINK',
  UPCOMING_MEETING_CALENDAR_CONNECT = 'UPCOMING_MEETING_CALENDAR_CONNECT',
  UPCOMING_MEETING_SAW_CALENDAR_DISCONNECTED_STATE = 'UPCOMING_MEETING_SAW_CALENDAR_DISCONNECTED_STATE',
  UPCOMING_MEETING_SAW_EMPTY_STATE = 'UPCOMING_MEETING_SAW_EMPTY_STATE',
  UPCOMING_MEETING_SAW_MEETINGS = 'UPCOMING_MEETING_SAW_MEETINGS',
  MEETING_TRANSCRIPT_TOGGLED = 'MEETING_TRANSCRIPT_TOGGLED',
  GO_TO_DEAL_ROOM_CLICKED = 'GO_TO_DEAL_ROOM_CLICKED',
  LOADED_MISSED_ACCOUNTS_REPORT = 'LOADED_MISSED_ACCOUNTS_REPORT',
  // CCRM session metrics
  CCRM_SESSION_START = 'CCRM_SESSION_START',
  CCRM_SESSION_SHORT = 'CCRM_SESSION_SHORT',
  CCRM_SESSION_MEDIUM = 'CCRM_SESSION_MEDIUM',
  CCRM_SESSION_LONG = 'CCRM_SESSION_LONG',
  CCRM_FEED_CARD_DWELL_TIME = 'CCRM_FEED_CARD_DWELL_TIME',
  COPIED_LINK_TO_CCRM_FEED_CARD = 'COPIED_LINK_TO_CCRM_FEED_CARD',
  // Insight Card Page metrics
  INSIGHT_CARD_PAGE_LINKEDIN_CLICK = 'INSIGHT_CARD_PAGE_LINKEDIN_CLICK',
  INSIGHT_CARD_PAGE_CHAT_CLICK = 'INSIGHT_CARD_PAGE_CHAT_CLICK',
  INSIGHT_CARD_PAGE_OUTREACH_ENROLL_CLICK = 'INSIGHT_CARD_PAGE_OUTREACH_ENROLL_CLICK',
  INSIGHT_CARD_PAGE_SALESLOFT_ENROLL_CLICK = 'INSIGHT_CARD_PAGE_SALESLOFT_ENROLL_CLICK',
  INSIGHT_CARD_PAGE_EMAIL_CLICK = 'INSIGHT_CARD_PAGE_EMAIL_CLICK',
  BACK_TO_FEED_FROM_INSIGHT_CARD_PAGE = 'BACK_TO_FEED_FROM_INSIGHT_CARD_PAGE',
  INSIGHT_CARD_PAGE_OPENED = 'INSIGHT_CARD_PAGE_OPENED',
  // Commenting
  COMMENT_CREATED = 'COMMENT_CREATED',
  COMMENT_UPDATED = 'COMMENT_UPDATED',
  COMMENT_DELETED = 'COMMENT_DELETED',
  COMMENT_ACTION_CLICKED = 'COMMENT_ACTION_CLICKED',
  COMMENT_COUNT_CLICKED = 'COMMENT_COUNT_CLICKED',
  // Timeline
  TIMELINE_MONTH_CHANGE = 'TIMELINE_MONTH_CHANGE',
  TIMELINE_DAY_HOVERED = 'TIMELINE_DAY_HOVERED',
  TIMELINE_DAY_CLICKED = 'TIMELINE_DAY_CLICKED'
}

export const segmentTrack = (event: TrackType, attrs = {}) => {
  if (window?.analytics?.track) {
    window.analytics.track(`PROSPECTOR_${event}`, attrs)
  }
}
